export default __webpack_public_path__ + "static/media/Visa.864460fb.svg";